import { useEffect } from 'react';

const useOutsideClickAction = (action: Function, ref: any, secondRef?: any) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (secondRef) {
          if (!secondRef.current.contains(event.target)) action();
        } else {
          action();
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, action, secondRef]);
};

export default useOutsideClickAction;
